import { localized } from "@msuite/ui/localization";
import { createColumnHelper, createRowActions } from "@msuite/ui/table";
import type { ArticleListItem } from "@msuite/utils/types";
import { OrderFormArticlesHintInput } from "./order-form-articles-hint";
import { OrderFormArticlesQuantityInput } from "./order-form-articles-quantity-input";
import { RowActions } from "./row-actions";

const columnHelper = createColumnHelper<ArticleListItem>();

export const columns = [
	columnHelper.display({
		id: "quantity",
		header: localized("general.quantity"),
		cell: (cell) => <OrderFormArticlesQuantityInput item={cell.row.original} />,
		enableSorting: false,
		enableHiding: false,
		enableColumnFilter: false,
	}),
	columnHelper.display({
		id: "hint",
		header: "",
		cell: (cell) => <OrderFormArticlesHintInput item={cell.row.original} />,
	}),
	createRowActions(RowActions),
];
